// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"companies_wrapper__2KHwD","company":"companies_company__2mAEu","SeeAllSpeakers":"companies_SeeAllSpeakers__2PeKq","icon":"companies_icon__uEpzF"};